import { render, staticRenderFns } from "./Callsheetmetadata.vue?vue&type=template&id=618bb1a4"
import script from "./Callsheetmetadata.vue?vue&type=script&lang=js"
export * from "./Callsheetmetadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports